import { createAction } from 'redux-act';

export const updateMemberLinkAction = createAction('Update Member Link');
export const updateLinkEntityAction = createAction('Update Link Entity');
export const archiveLinkEntityAction = createAction('Archive Link Entity');
export const updateVlanAction = createAction('Update VLAN');
export const updateNativeRouterAction = createAction('Update Native Router');
export const updateSpeedAndInterfaceTypeAction = createAction('Update Speed and Interface Type');
export const updateCrossIxConnectionAction = createAction('Update cross IX connection');
export const updateMailingListAction = createAction('Update mailing list');
export const deleteMailingListAction = createAction('Delete mailing list');
